import type { PropTypes } from './Avatar.types';
import type { ReactElement } from 'react';

import { bottts } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import { Avatar as WhaleAvatar } from '@rango-dev/whale';
import React, { useMemo } from 'react';

/*
 * dicebear produces SVG which scales to any display size, so we render it at
 * a generous fixed resolution and let the wrapper control the final size.
 */
const DICEBEAR_RENDER_SIZE = 128;

export function Avatar(props: PropTypes): ReactElement {
  const { size, username, className } = props;

  const avatarSrc = useMemo(() => {
    const avatar = createAvatar(bottts, {
      seed: username,
      size: DICEBEAR_RENDER_SIZE,
    });
    return avatar.toDataUri();
  }, [username]);

  return <WhaleAvatar size={size} src={avatarSrc} className={className} fallback="?" />;
}
